import { catchError, combineLatest, debounceTime, filter, firstValueFrom, from, identity, map, merge, of, pipe, switchMap, } from 'rxjs';
import { Failure, Initialized, isSuccess, Pending, Success } from './remote-data';
/** Convert an API Action into a RemoteData object. */
export function handleApiAction(action, payloadMapper = ((payload) => payload)) {
    return action.error
        ? new Failure(action.payload)
        : new Success(payloadMapper(action.payload));
}
/** Check if API response is error */
export function isApiError(response) {
    return response.error ?? false;
}
/** RxJS */
/** Convert an API Response into a RemoteData object */
export function convertToRemoteData(res) {
    if (isApiError(res)) {
        return new Failure({
            ...res.data,
            trace: res.data?.body?.trace,
            message: res.data?.body?.message || res.data?.message || 'Unknown API error',
        });
    }
    return new Success(res.data);
}
/** Filter an observable for `Success` values and emit the bare value */
export const pluckSuccessData = (s) => pipe(filter(isSuccess), map((s) => s.data))(s);
/** Creates an observable that emits `Initialized` first. */
export function initRemoteData$(source) {
    return merge(of(new Initialized()), source);
}
/** like `switchMap` but converts api operations to remote data. */
export function switchMapRemoteData(cb) {
    return switchMap((value) => merge(of(new Pending()), from(cb(value)).pipe(map(convertToRemoteData), catchError((e) => of(new Failure({ message: e.message }))))));
}
/** Fetch remote data from the API based on inputs. */
export function fetchRemoteData$(input, operation, { debounce = 500 } = {}) {
    return initRemoteData$(combineLatest(input).pipe(debounce ? debounceTime(debounce) : identity, switchMapRemoteData((params) => operation(...params))));
}
// TODO(ED-2458): fetchReduxRemoteData$, check https://github.com/granodigital/grano-remote-data/pull/1#discussion_r1771318440
/** Like RxJS `firstValueFrom` but for RemoteData Success values. */
export async function firstSuccessFrom(s) {
    return firstValueFrom(s.pipe(pluckSuccessData));
}
